import PensionVideoContentBox from './PensionVideoContentBox';

export default PensionVideoContentBox;
